import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useStores } from "../../../../stores/setup/use-store";
import { LocationFormValues } from "../types";

export function useOperationRuleLocationDrawing() {
	const {
		dataStores: {
			forecastChartPageStore,
			operationRuleLocationStore,
			oceanWeatherIntelligenceStore
		},
	} = useStores();

	const history = useHistory();

	const handleDrawingMode = useCallback((formValues?: LocationFormValues, isEditing?: boolean) => {
		forecastChartPageStore.setIsAreaDrawingMode(true);

		if (formValues) {
			operationRuleLocationStore.setCreateFormValues(formValues);
		}

		let geofence = formValues?.geofence || operationRuleLocationStore.operationRuleLocation?.geofence || [];

		if (geofence.length > 0) {
			oceanWeatherIntelligenceStore.setSelectedGeofence(geofence);
		}

		const locationId = operationRuleLocationStore.operationRuleLocation?.id;

		if (locationId && isEditing) {
			history.push(`/forecast-charts?operation_rule_location_id=${locationId}`);
		} else if (isEditing && !locationId) {
			history.push(`/forecast-charts?operation_rule_location_id=new`);
		} else {
			history.push(`/forecast-charts?operation_rule_location_id=new`);
		}
	}, [forecastChartPageStore, history, operationRuleLocationStore, oceanWeatherIntelligenceStore]);

	const exitDrawingMode = useCallback(() => {
		forecastChartPageStore.setIsAreaDrawingMode(false);
	}, [forecastChartPageStore]);

	return {
		handleDrawingMode,
		exitDrawingMode,
		isAreaDrawingMode: forecastChartPageStore.isAreaDrawingMode,
	};
}
